<template>
    <div>
        <div id="figures" v-if="location == 1">
            <img src="/assets/img/figures-g-green-hor.svg" class="figure girl-green" />
            <img src="/assets/img/figures-g-yellow-hor.svg" class="figure girl-yellow" />
            <img src="/assets/img/figures-g-b-hor.svg" class="figure girl-boy" />
            <img src="/assets/img/figures-b-g-hor.svg" class="figure boy-girl" />
        </div>

        <div id="figures" v-if="location == 2">
            <img src="/assets/img/figures-g-green-kus.svg" class="figure girl-green" />
            <img src="/assets/img/figures-g-yellow-kus.svg" class="figure girl-yellow" />
            <img src="/assets/img/figures-g-b-kus.svg" class="figure girl-boy" />
            <img src="/assets/img/figures-b-g-kus.svg" class="figure boy-girl" />
        </div>


         <!-- Evt können ale Controls mit "style="display:none;""   gelöscht werden. Muss noch geprüft werden -->
        <section class="offer page-wrapper-inner" v-if="dataIsInit">
            <div class="block">
                <div>
                    <label class="subtitle horgen" v-if="location == 1">Horgen</label>
                    <label class="subtitle kuesnacht"  v-if="location == 2">Küsnacht</label>
                    <h2>Pre-Kindergarten</h2>
                    <p>{{ trans.prekinder.intro[lang] }}</p>
                    <!-- <ul class="link-block">
                        <li><a href="#" class="more">{{ trans.global.organisation[lang] }} +</a></li>
                        <li><a href="#" class="more">{{ trans.global.terms[lang] }} +</a></li>
                    </ul> -->
                </div>
                <ul>
                    <li v-bind:class="[mode && mode != 'week' ? 'optionblock disabled' : 'optionblock' ]">
                        <label v-on:click="mode = 'week'">
                            <span v-bind:class="[mode == 'week' ? 'checkbox checked' : 'checkbox', ]"></span>
                            {{ trans.global.everyday[lang] }}
                        </label>
                        <div   v-bind:class="[{'active':mode=='week'} , 'hidebox']">
                            <h5>{{ trans.prekinder.choose[lang] }} </h5>
                            <ul class="block-list">
                                <li v-bind:class="[selectionOptions[0].timerange && selectionOptions[0].timerange != 'fullday' ? 'disabled' : '' ]">
                                    <label v-on:click="selectionOptions[0].timerange = 'fullday'" class="checkbox-indent">
                                        <span v-bind:class="[selectionOptions[0].timerange == 'fullday' ? 'checkbox checked' : 'checkbox', ]"></span>
                                        {{ trans.global.fullday[lang] }}
                                    </label>
                                    <span>{{ trans.global.chf_month[lang] }}</span>

                                    <em v-if="mode == 'week' && selectionOptions[0].timerange == 'fullday'">{{ priceSummary | francs}}</em>
                                    <em v-else>{{ displaypriceWeekFullday | francs }} </em>

                                    <div v-if="selectionOptions[0].timerange == 'fullday'" class="noflex indent-block" >
                                        <h5><img src="/assets/img/icon-lunch.svg" /> {{ trans.global.hotluch_onwichdays[lang] }}</h5>
                                        <lunch-component :trans="trans" :lang="lang" ref="lunch" class="noflex" :onlyDiDo="false" :options="[
                                                {id:'mo',label: trans.global.monday[lang],isActive: false},
                                                {id:'di',label: trans.global.tuesday[lang],isActive: false},
                                                {id:'do',label: trans.global.thursday[lang],isActive: false},
                                                {id:'fr',label: trans.global.friday[lang],isActive: false}
                                            ]" :status-open="true" :service="lunchService" :selections="selections" :location="location" :session="session" :labelAllDaysWithoutWe="true"
                                            @submited="importLunchdata"
                                        ></lunch-component>
                                    </div>
                                </li>
                                <li v-bind:class="[selectionOptions[0].timerange && selectionOptions[0].timerange != 'morning' ? 'disabled' : '' ]">
                                    <label v-on:click="selectionOptions[0].timerange = 'morning'" class="checkbox-indent">
                                        <span v-bind:class="[selectionOptions[0].timerange == 'morning' ? 'checkbox checked' : 'checkbox', ]"></span>
                                        {{ trans.global.mornings[lang] }}
                                    </label>
                                    <span>{{ trans.global.chf_month[lang] }}</span>
                                    <em v-if="mode == 'week' && selectionOptions[0].timerange == 'morning'">{{ priceSummary | francs}}</em>
                                    <em v-else>{{ displaypriceWeekMorning | francs }} </em>

                                    <div v-if="selectionOptions[0].timerange == 'morning'" class="noflex indent-block">
                                        <h5><img src="/assets/img/icon-clock.svg" />{{ trans.prekinder.choose_period[lang]}}</h5>

                                        <div class="select-wrapper">
                                            <select v-model="selectionOptions[0].end">
                                                <option :value="config.endBeforeLunch">{{ trans.global.until[lang] }} {{ config.endBeforeLunch }}</option>
                                                <option :value="config.endAfterLunch">{{ trans.global.until[lang] }} {{ config.endAfterLunch }}</option>
                                            </select>
                                        </div>
                                        <div class="" v-if="selectionOptions[0].end == config.endAfterLunch">
                                            <h5><img src="/assets/img/icon-lunch.svg" /> {{ trans.global.hotluch_onwichdays[lang] }}</h5>
                                            <lunch-component :trans="trans" :lang="lang" ref="lunch" class="noflex" :onlyDiDo="false"
                                                    :options="[
                                                    {id:'mo',label: trans.global.monday[lang],isActive: false},
                                                    {id:'di',label: trans.global.tuesday[lang],isActive: false},
                                                    {id:'do',label: trans.global.thursday[lang],isActive: false},
                                                    {id:'fr',label: trans.global.friday[lang],isActive: false}
                                                ]"

                                                :noindividual="false" :status-open="true" :service="lunchService" :selections="selections" :location="location" :session="session"
                                                @submited="importLunchdata"
                                            ></lunch-component>
                                        </div>

                                    </div>
                                </li>
                            </ul>


                    </div>

                </li>
               <li v-bind:class="[mode && mode != 'days' ? 'optionblock disabled' : 'optionblock' ]">
                    <label v-on:click="mode = 'days'">
                        <span v-bind:class="[mode == 'days' ? 'checkbox checked' : 'checkbox', ]"></span>
                        {{ trans.global.dayofchoise[lang] }}
                    </label>
                        <div   v-bind:class="[{'active':mode=='days'} , 'hidebox']">
                         <h6>
                            <p>{{ trans.prekinder.choose_4days[lang] }} </p>

                            <p v-if="location == 1">{{ trans.prekinder.info_wednesday_horgen[lang] }}</p>
                            <p v-if="location == 2">{{ trans.prekinder.info_wednesday_kuesnacht[lang] }}</p>

                        </h6>
                       <ul class="block-list">
                        <li v-for="day in days" :key="day.id">

                                <label :for="'status_' + day.id" class="checkbox-indent">
                                    <input style="display:none;" type="checkbox" v-model="selectionOptions[day.id].active" :id="'status_' + day.id" value="true">
                                    <span v-bind:class="[selectionOptions[day.id].active  ? 'checkbox checked' : 'checkbox', ]"></span>
                                    {{ day.name }}
                                </label>
                                <span v-if="selectionOptions[day.id].active">{{ trans.global.chf_month[lang] }}</span>
                                <em v-if="selectionOptions[day.id].active && selectionOptions[day.id].timerange == 'morning'">
                                    {{ displaypriceDayMorning + (selectionOptions[day.id].lunch ?  lunchService.relevantPrice.price_brutto : 0) | francs }}
                                </em>
                                <em v-if="selectionOptions[day.id].active && selectionOptions[day.id].timerange == 'fullday'">
                                    {{ displaypriceDayFullday + (selectionOptions[day.id].lunch ?  lunchService.relevantPrice.price_brutto : 0) | francs }}
                                </em>


                                <div v-if="selectionOptions[day.id].active" class="noflex indent-block">

                                    <div v-if="day.id != 'mi'">

                                         <ul class="subblock-list margin">

                                            <li>
                                                <label  :for="'morning_' + day.id"  >
                                                    <span v-bind:class="[selectionOptions[day.id].timerange == 'morning'  ? 'checkbox checked' : 'checkbox', ]"></span>
                                                    <input style="display:none;" type="radio" value="morning" :id="'morning_' + day.id" :name="'fullday_' + day.id" v-model="selectionOptions[day.id].timerange" />
                                                    {{ trans.global.mornings[lang] }}
                                                </label>

                                                 <div class="" v-if="selectionOptions[day.id].timerange == 'morning'">
                                                    <div class="indent">
                                                        <h5 class=""><img src="/assets/img/icon-clock.svg" />{{ trans.prekinder.choose_period[lang]}}</h5>
                                                        <div class="select-wrapper">
                                                            <select v-model="selectionOptions[day.id].end" v-bind:change="checkLunchesOnDayMode(day.id)">
                                                                <option :value="config.endBeforeLunch">{{ trans.global.until[lang] }} {{ config.endBeforeLunch }}</option>
                                                                <option :value="config.endAfterLunch">{{ trans.global.until[lang] }} {{ config.endAfterLunch }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>


                                            </li>
                                             <li>
                                                <label  :for="'fullday_' + day.id" >
                                                    <span v-bind:class="[selectionOptions[day.id].timerange == 'fullday'  ? 'checkbox checked' : 'checkbox', ]"></span>
                                                    <input style="display:none;" type="radio" value="fullday" :id="'fullday_' + day.id" :name="'fullday_' + day.id" v-model="selectionOptions[day.id].timerange" />
                                                    {{ trans.global.fullday[lang] }}
                                                </label>
                                            </li>
                                        </ul>



                                        <div  v-if="selectionOptions[day.id].end == config.endAfterLunch || selectionOptions[day.id].timerange == 'fullday'">

                                            <input style="display:none;" type="checkbox" value="true" :id="'lunch_' + day.id" :name="'lunch_' + day.id" v-model="selectionOptions[day.id].lunch" />
                                            <div class="price-row">
                                                <label :for="'lunch_' + day.id">
                                                    <img src="/assets/img/icon-lunch-dark.svg" style="margin-right:0.5em"/>
                                                    <span v-bind:class="[selectionOptions[day.id].lunch  ? 'checkbox checked' : 'checkbox', ]"></span>

                                                     {{ trans.global.mithotlunch[lang] }}
                                                </label>
                                                <span v-if="selectionOptions[day.id].lunch">
                                                   {{ trans.global.chf_month[lang] }}<br>
                                                    8.1%  {{ trans.global.mwst[lang] }}
                                                </span>
                                                <em v-if="selectionOptions[day.id].lunch">{{ lunchService.relevantPrice.price | francs }}<br><span>{{ lunchService.relevantPrice.price | francsVat }}</span></em>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                        </li>
                       </ul>


                    </div>
                </li>

                 <!-- Summary alldays -->
                <li style="border-top:0" v-bind:class="[mode && mode != 'week' ? 'optionblock hidden' : 'optionblock' ]">
                    <div style="margin-top:5vw" class="applicationbox" v-if="selectionOptions[0].timerange">
                        <p>{{ trans.global.c2a_finish[lang] }}</p>
                        <button class="btn  btnoutline" v-on:click="prepareData('pdf')">{{ trans.global.downloadpdf[lang] }}</button>
                        <button class="btn" v-on:click="prepareData('app')">{{ trans.global.register[lang] }}</button>
                    </div>
                </li>

                 <!-- Summary halfdays -->


                 <li style="border-top:0;padding-top:2vw" v-bind:class="[mode != 'days' ? 'optionblock hidden' : 'optionblock' ]">

                    <span class="infobox" v-if="choosenDaysHalf.length + (choosenDaysFull.length*2) < 4">
                        <img src="/assets/img/icon-info.svg" /><br>
                        <div v-if="lang=='de'">
                            Es  <i v-if="4 - choosenDaysHalf.length - (choosenDaysFull.length*2) == 1">fehlt noch 1 Halbtag</i><i v-else>fehlen noch {{ 4 - choosenDaysHalf.length - (choosenDaysFull.length*2) }} Halbtage</i> um weiterzufahren.
                            <br>Bitte wählen Sie  {{ 4 -  choosenDaysHalf.length - (choosenDaysFull.length * 2) }} <i v-if="4 - choosenDaysHalf.length - (choosenDaysFull.length*2) == 1">  weiteren Halbtag</i><i v-else> weitere Halbtage</i> aus.
                        </div>
                        <div v-if="lang=='en'">
                            Please choose
                            <i v-if="4 - choosenDaysHalf.length - (choosenDaysFull.length*2) == 1">an addtional half day</i><i v-else> addtional half days</i>
                            in order to continue. Pre-Kindergarten registration requires a minimum of 4.5 days.
                        </div>
                    </span>

                    <div class="summarybox">
                        <label>{{ trans.global.chf_month_total[lang] }}:</label>
                        <em>{{ priceSummary | francs}}</em>
                    </div>

                        <div class="applicationbox" v-if="choosenDaysHalf.length + (choosenDaysFull.length*2) >= 4">
                        <p>{{ trans.global.finishing_next[lang] }} {{ trans.global.finishing_save[lang] }}</p>
                        <button class="btn" v-on:click="prepareData('pdf')">{{ trans.global.downloadpdf[lang] }}</button>


                        <button class="btn" v-if="appmode=='offer'" v-on:click="prepareData('app')">{{ trans.global.register[lang] }}</button>
                        <button class="btn" v-if="appmode=='change'" v-on:click="prepareData('app')">{{ trans.global.confirm[lang] }}</button>

                        <!-- <br><br>
                        <a v-if="appmode == 'offer' && location == 1" href="/daycare/horgen/1/offer" class="btn btnoutline" >{{ trans.global.daycare_btn[lang] }}</a>
                        <a v-if="appmode == 'change' && location == 1" href="/daycare/horgen/1/change" class="btn btnoutline" >{{ trans.global.daycare_btn[lang] }}</a>
                        <a v-if="appmode == 'offer' && location == 2" href="/daycare/kuesnacht/2/offer" class="btn btnoutline" >{{ trans.global.daycare_btn[lang] }}</a>
                        <a v-if="appmode == 'change' && location == 2" href="/daycare/kuesnacht/2/change" class="btn btnoutline" >{{ trans.global.daycare_btn[lang] }}</a> -->

                    </div>

                </li>



            </ul>



            </div>
        </section>


        <div class="teaser-wrapper">
            <h3 class="title"></h3>
            <div class="grid">
                <div class="teaser internal">
                    <p>{{ trans.teaser.daycare.text[lang] }}</p>
                    <a :href="trans.teaser.daycare.link[location][lang]" target="_blank">{{ trans.teaser.daycare.linktext[lang] }}</a>
                </div>
                <div class="teaser internal">
                    <p>{{ trans.teaser.contact.text[lang] }}</p>
                    <a :href="trans.teaser.contact.link[location][lang]" target="_blank">{{ trans.teaser.contact.linktext[lang] }}</a>
                </div>
            </div>
            <div class="grid">
                 <div class="teaser">
                    <p v-html="trans.teaser.about_pre.text[lang]"></p>
                    <a :href="trans.teaser.about_pre.link[location][lang]" target="_blank">{{ trans.teaser.about_pre.linktext[lang] }}</a>
                </div>
                <div class="teaser">
                    <p v-html="trans.teaser.video_pre.text[lang]"></p>
                    <a :href="trans.teaser.video_pre.link[location][lang]" target="_blank">{{ trans.teaser.video_pre.linktext[lang] }}</a>
                </div>

            </div>
        </div>




        <div v-if="dataIsInit" style="color:#FAF9F7">
            <br>Price : {{ price }} / {{ choosenSelectionDayMorning.quantity }} / {{ choosenSelectionDayFullday.quantity }}
            <br>Price Lunch: {{ lunchPriceTotal }}
            <br>Total: {{ priceSummary }}
        </div>



    </div>
</template>



<script>

    import * as helpers from "./helpers.js";
    import * as methods from "./methods.js";

    export default {

        data: function() {

            let endBeforeLunch = '11:45';
            let endAfterLunch = '13:30';

            return  {
                days: [
                    { id: 'mo', name: this.trans.global.monday[this.lang], lunch: true },
                    { id: 'di', name: this.trans.global.tuesday[this.lang], lunch: true },
                    { id: 'mi', name: this.trans.global.wednesday[this.lang], lunch: false },
                    { id: 'do', name: this.trans.global.thursday[this.lang], lunch: true },
                    { id: 'fr', name: this.trans.global.friday[this.lang], lunch: true }
                ],

                config:{
                    sectorIds: [ 2 , 5 ], // Pre-Kindergarten, Sonstiges
                    serviceIdWeekFullday: 10,
                    serviceIdWeekMorning: 11,
                    serviceIdDayFullday: 12,
                    serviceIdDayMorning: 13,
                    serviceIdLunchs: 17,
                    endBeforeLunch: endBeforeLunch,
                    endAfterLunch: endAfterLunch,
                },

                selectionOptions: {
                    0: {
                        type: 'week',
                        timerange: null,
                        end: endBeforeLunch,
                    },
                    'mo': {
                        type: 'day',
                        active: false,
                        timerange: 'morning',
                        end: endBeforeLunch,
                        lunch: false
                    },
                    'di': {
                        type: 'day',
                        active: false,
                        timerange: 'morning',
                        end: endBeforeLunch,
                        lunch: false
                    },
                    'mi': {
                        type: 'day',
                        active: false,
                        timerange: 'morning',
                        end: endBeforeLunch,
                        lunch: false
                    },
                    'do': {
                        type: 'day',
                        active: false,
                        timerange: 'morning',
                        end: endBeforeLunch,
                        lunch: false
                    },
                    'fr': {
                        type: 'day',
                        active: false,
                        timerange: 'morning',
                        end: endBeforeLunch,
                        lunch: false
                    }
                },
                choosenSelectionIds: {
                    week: null,
                    dayMorning: null,
                    dayFullday: null,
                },
                mainservice: null,
                services: [],
                errors: [],
                selections: [],
                selectionsOrigin: [],
                selectionsToSubmit: [],
                deletedTimetables: [],
                mode: null,
                dataIsInit: false,

            }
        },
        props: {

            location: {
                type: Number,
                required: true
            },
            lang: {
                type: String,
                required: true
            },
            trans: {
                type: Object,
                required: true
            },
            session: {
                type: String,
                required: true
            },
            appmode: {
                type: String,
                required: true
            },
        },
        computed: {
            lunchService: function () {
                let id = this.config.serviceIdLunchs;
                var service = this.services.filter(function(item) {
                    return item.id == id;
                });
                return service[0];
            },
            lunchSelections: function () {
                let app = this;
                return this.selections.filter(function(item) {
                    return item.service_id == app.config.serviceIdLunchs;
                });
            },
            modulRelevantSelections: function () {
                let app = this;
                return this.selections.filter(function(item) {
                    let found = app.services.find(element => element.id == item.service_id);
                    return found !== undefined
                });
            },
            choosenSelectionWeek: function () {
                let app = this;
                return this.selections.filter(function(item) {
                    return app.choosenSelectionIds['week'] == item.id;
                })[0];
            },
            choosenSelectionDayMorning: function () {
                let app = this;
                return this.selections.filter(function(item) {
                    return app.choosenSelectionIds['dayMorning'] == item.id;
                })[0];
            },
            choosenSelectionDayFullday: function () {
                let app = this;
                return this.selections.filter(function(item) {
                    return app.choosenSelectionIds['dayFullday'] == item.id;
                })[0];
            },
            choosenSelectionDay: function () {
                let app = this;
                return this.selections.filter(function(item) {
                    return app.choosenSelectionIds['dayFullday'] == item.id || app.choosenSelectionIds['dayMorning'] == item.id;
                })[0];
            },

            choosenDays: function () {
                let app = this;
                let days = [];
                for(var index in app.selectionOptions) {
                    if(app.selectionOptions[index].type == 'day' && app.selectionOptions[index].active === true){
                        days.push(app.selectionOptions[index]);
                    }
                }
                return  days;
            },
            choosenDaysFull: function () {
                let app = this;
                let days = [];
                for(var index in app.selectionOptions) {
                    if(app.selectionOptions[index].type == 'day' && app.selectionOptions[index].active === true && app.selectionOptions[index].timerange == 'fullday'){
                        days.push(app.selectionOptions[index]);
                    }
                }
                return  days;
            },
            choosenDaysHalf: function () {
                let app = this;
                let days = [];
                for(var index in app.selectionOptions) {
                    if(app.selectionOptions[index].type == 'day' && app.selectionOptions[index].active === true && app.selectionOptions[index].timerange == 'morning'){
                        days.push(app.selectionOptions[index]);
                    }
                }
                return  days;
            },
            displaypriceWeekFullday: function () {
                let app = this;
                let serv = app.services.filter(function(item) { return item.id == app.config.serviceIdWeekFullday});
                return serv[0].relevantPrice.price_brutto
            },
            displaypriceWeekMorning: function () {
                let app = this;
                let serv = app.services.filter(function(item) { return item.id == app.config.serviceIdWeekMorning});
                return serv[0].relevantPrice.price_brutto
            },
             displaypriceDayFullday: function () {
                let app = this;
                let serv = app.services.filter(function(item) { return item.id == app.config.serviceIdDayFullday});
                return serv[0].relevantPrice.price_brutto
            },
            displaypriceDayMorning: function () {
                let app = this;
                let serv = app.services.filter(function(item) { return item.id == app.config.serviceIdDayMorning});
                return serv[0].relevantPrice.price_brutto
            },
            price: function () {
                let app = this;
                let price = 0;
                if(app.mode == 'week')
                {
                    price =  app.choosenSelectionWeek.service.relevantPrice.price_brutto;
                }
                else
                {
                     price =
                     (app.choosenSelectionDayMorning.service.relevantPrice.price_brutto * app.choosenSelectionDayMorning.quantity)
                     +
                     (app.choosenSelectionDayFullday.service.relevantPrice.price_brutto * app.choosenSelectionDayFullday.quantity);
                }
                return price
            },
            lunchPriceTotal: function () {
                var price = 0;
                for(var i = 0; i < this.lunchSelections.length; i++)
                {
                    price = price + this.lunchSelections[i].service.relevantPrice.price_brutto;
                }
                return price
            },
            priceSummary: function () {
                return this.price + this.lunchPriceTotal
            }
        },
        watch: {
            selectionOptions: {
                handler() {
                    this.checkCondition();
                },
                deep: true
            },
            mode: function(){
                this.setLunches()
            }
        },
        mounted() {
            this.loadData();
        },
        methods: {
            loadData() {
                let app = this;
                // load for each sector the services
                axios.get('/api/services/bysectors/' + this.config.sectorIds.join() + '/' + this.location)
                .then(response => {
                    this.services = this.services.concat(response.data);
                    axios.get('/api/session/data/' + this.session )
                        .then(response => {
                            // this.selections = response.data.selections.filter(function(item) {
                            //     return item.location_id == app.location;
                            // });
                            this.selections = [];
                            this.selectionsOrigin = this.selections;
                            app.dataInit();
                        })
                        .catch(e => {
                            this.errors.push(e)
                        });
                })
                .catch(e => {
                    this.errors.push(e)
                });
            },

            dataInit() {

                let app = this;

                let weekAll = this.getSingleSelection( [ app.config.serviceIdWeekFullday,app.config.serviceIdWeekMorning ] );
                let dayFullday = this.getSingleSelection( [ app.config.serviceIdDayFullday ] );
                let dayMorning = this.getSingleSelection( [ app.config.serviceIdDayMorning ] );

                // delete unused selections
                if(weekAll.length > 0 )
                {
                    app.mode = 'week';
                    if(weekAll[0].service_id == app.config.serviceIdWeekMorning)
                    {
                        app.selectionOptions[0].timerange = 'morning';
                        app.selectionOptions[0].end = weekAll[0].timetables[0].timeend;
                    }
                }
                if(dayFullday.length > 0 || dayMorning.length > 0)
                {
                    app.mode = 'days';
                }

                if(weekAll.length == 0){
                    weekAll[0] = app.createNewSelection(app.config.serviceIdWeekFullday);
                }
                if(dayMorning.length == 0){
                    dayMorning[0] = app.createNewSelection(app.config.serviceIdDayMorning);
                }
                if(dayFullday.length == 0){
                    dayFullday[0] = app.createNewSelection(app.config.serviceIdDayFullday);
                }

                app.$set(app.choosenSelectionIds, 'dayMorning', dayMorning[0].id)
                app.$set(app.choosenSelectionIds, 'dayFullday', dayFullday[0].id)
                app.$set(app.choosenSelectionIds, 'week', weekAll[0].id)


                // select days by timetables
                for(let i = 0; i < app.choosenSelectionDayFullday.timetables.length; i++)
                {
                    app.$set(app.selectionOptions[app.choosenSelectionDayFullday.timetables[i].weekday], 'active', true)
                }
                for(let i = 0; i < app.choosenSelectionDayMorning.timetables.length; i++)
                {
                    app.$set(app.selectionOptions[app.choosenSelectionDayMorning.timetables[i].weekday], 'active', true)
                    app.$set(app.selectionOptions[app.choosenSelectionDayMorning.timetables[i].weekday], 'timerange','morning')
                    app.$set(app.selectionOptions[app.choosenSelectionDayMorning.timetables[i].weekday], 'end', app.choosenSelectionDayMorning.timetables[i].timeend)
                }

                app.setLunches();


                app.checkCondition();
                app.dataIsInit = true;

            },


            checkCondition()
            {
                let app = this;
                let serv;

                if( app.selectionOptions[0].timerange == 'fullday' )
                {
                    serv = app.services.filter(function(item) { return item.id == app.config.serviceIdWeekFullday});
                };

                if( app.selectionOptions[0].timerange == 'morning' )
                {
                    serv = app.services.filter(function(item) { return item.id == app.config.serviceIdWeekMorning});
                }
                if(serv)
                {
                    app.choosenSelectionWeek.service_id = serv[0].id;
                    app.choosenSelectionWeek.service = serv[0];
                }


                let dayFulldays = [];
                for(var index in app.selectionOptions) {
                    if(app.selectionOptions[index].type == 'day' && app.selectionOptions[index].active === true && app.selectionOptions[index].timerange == 'fullday'){
                        dayFulldays.push(app.selectionOptions[index]);
                    }
                }
                app.$set(app.choosenSelectionDayFullday, 'quantity', dayFulldays.length)

                let dayMornings = [];
                for(var index in app.selectionOptions) {
                    if(app.selectionOptions[index].type == 'day' && app.selectionOptions[index].active === true && app.selectionOptions[index].timerange == 'morning'){
                        dayMornings.push(app.selectionOptions[index]);
                    }
                }
                app.$set(app.choosenSelectionDayMorning, 'quantity', dayMornings.length);

                // handle lunches
                for(var index in app.selectionOptions) {
                    if(app.selectionOptions[index].type == 'day')
                    {
                        let lunchSelection = app.lunchSelections.find(element => element.timetables[0].weekday == index);

                        if(app.selectionOptions[index].lunch === false && lunchSelection) // delete in selection
                        {
                            app.selections = app.selections.filter(function(item)
                            {
                                return lunchSelection.id != item.id
                            });
                        };
                        if(app.selectionOptions[index].lunch === true && lunchSelection == undefined) // add in selection
                        {
                            let timetables = [];
                            let id = app.generateString(12);
                            timetables[0] = {
                                id: app.generateString(12),
                                weekday: index,
                                selection_id: id,
                            }
                            app.selections.push(
                                {
                                    id: id,
                                    service_id: app.lunchService.id,
                                    service: app.lunchService,
                                    location_id: app.$props.location,
                                    timetables: timetables,
                                    session_id: app.$props.session,
                                }
                            );
                        }

                    }
                }

            },

            prepareData(next='pdf')
            {
                let app = this;
                let servicesection_id = 2; // prekindergarten



                /// manage timetables for individual days
                for(var index in app.selectionOptions) {
                    if(app.selectionOptions[index].timerange == 'fullday' && app.selectionOptions[index].type == 'day' && app.selectionOptions[index].active === true){

                         let existingTimetable = app.choosenSelectionDayFullday.timetables.filter(function(item){
                             return item.weekday == index
                         })

                         if(existingTimetable.length == 0){
                            app.choosenSelectionDayFullday.timetables.push(
                                {
                                    id: this.generateString(12),
                                    weekday: index,
                                    selection_id: app.choosenSelectionDayFullday.id,
                                }
                            )
                         }

                    };
                    if(app.selectionOptions[index].timerange == 'morning' && app.selectionOptions[index].type == 'day' && app.selectionOptions[index].active === true){

                        let existingTimetable = app.choosenSelectionDayMorning.timetables.filter(function(item){
                             return item.weekday == index
                         })
                         if(existingTimetable.length == 0){
                            app.choosenSelectionDayMorning.timetables.push(
                                {
                                    id: this.generateString(12),
                                    weekday: index,
                                    timeend: app.selectionOptions[index].end,
                                    selection_id: app.choosenSelectionDayMorning.id,
                                }
                            )
                         }
                         else
                         {
                             existingTimetable[0].timeend = app.selectionOptions[index].end;
                             existingTimetable[0].selection_id = app.choosenSelectionDayMorning.id;
                         }
                    }
                }

                /// manage timetables for "week" morning
                if(app.selectionOptions[0].timerange == 'morning'){

                    // let existingTimetable = app.choosenSelectionWeek.timetables.filter(function(item){
                    //     return item.weekday == null
                    // })
                    // if(existingTimetable.length == 0){
                    //     app.choosenSelectionWeek.timetables.push(
                    //         {
                    //             id: this.generateString(12),
                    //             weekday: '',
                    //             selection_id: app.choosenSelectionWeek.id,
                    //             timeend: app.selectionOptions[0].end
                    //         }
                    //     )
                    // }
                    // else
                    // {

                        if(app.choosenSelectionWeek.timetables[0] === undefined){
                             app.choosenSelectionWeek.timetables.push(
                                {
                                    id: this.generateString(12),
                                    weekday: '',
                                    selection_id: app.choosenSelectionWeek.id,
                                    timeend: app.selectionOptions[0].end
                                }
                            )
                        }else{
                            app.choosenSelectionWeek.timetables[0].timeend = app.selectionOptions[0].end;
                            app.choosenSelectionWeek.timetables[0].selection_id = app.choosenSelectionWeek.id;
                        }

                    // }

                };



                // delete old timetables
                for(let i = app.choosenSelectionDayFullday.timetables.length - 1; i >= 0 ; i--){
                    let option = app.selectionOptions[app.choosenSelectionDayFullday.timetables[i].weekday];
                    if(option.active === false || option.timerange != 'fullday'){
                        let id = app.choosenSelectionDayFullday.timetables[i].id;
                        if(typeof id === 'number')
                        {
                            app.deletedTimetables.push(id);
                            app.choosenSelectionDayFullday.timetables.splice(i, 1);
                        }
                    }
                }
                for(let i = app.choosenSelectionDayMorning.timetables.length - 1; i >= 0 ; i--){
                    let option = app.selectionOptions[app.choosenSelectionDayMorning.timetables[i].weekday];
                    if(option.active === false || option.timerange != 'morning'){
                        let id = app.choosenSelectionDayMorning.timetables[i].id;
                        if(typeof id === 'number')
                        {
                            app.deletedTimetables.push(id);
                            app.choosenSelectionDayMorning.timetables.splice(i, 1);
                        }
                    }
                }
                // week
                for(let i = app.choosenSelectionWeek.timetables.length - 1; i >= 0 ; i--){
                    let option = app.selectionOptions[0];
                    if(option.active === false || option.timerange != 'morning'){
                        let id = app.choosenSelectionWeek.timetables[i].id;
                        if(typeof id === 'number')
                        {
                            app.deletedTimetables.push(id);
                            app.choosenSelectionWeek.timetables.splice(i, 1);
                        }
                    }
                }


                if(app.mode == 'week')
                {
                    app.selectionsToSubmit = app.modulRelevantSelections.filter(function(item) {
                        return item.service_id == app.config.serviceIdWeekFullday || item.service_id == app.config.serviceIdWeekMorning || item.service_id == app.config.serviceIdLunchs;
                    });
                }
                if(app.mode == 'days')
                {
                    app.selectionsToSubmit = app.modulRelevantSelections.filter(function(item) {
                        return ( item.service_id == app.config.serviceIdDayFullday &&  item.quantity > 0) ||
                        (item.service_id == app.config.serviceIdDayMorning &&  item.quantity > 0) ||
                        item.service_id == app.config.serviceIdLunchs;
                    });
                }
                app.storeData(app.selectionsToSubmit,servicesection_id,next);
            //    this.$forceUpdate();



            },

            setLunches(){
                let app = this;
                for(var index in app.selectionOptions) {
                    if(app.selectionOptions[index].type == 'day')
                    {
                        let lunchSelection = app.lunchSelections.find(element => element.timetables[0].weekday == index);

                        if(lunchSelection && app.selectionOptions[index].active == true)
                        {
                            app.selectionOptions[index].lunch = true;
                        }
                        else
                        {
                            app.selectionOptions[index].lunch = false;
                        }
                    }
                }
            },

            checkLunchesOnDayMode(day){
                let app = this;
                if(app.selectionOptions[day].end == app.config.endBeforeLunch)
                {
                   app.selectionOptions[day].lunch = false;
                }
            },




            ...helpers,
            ...methods,




        }

    }
</script>
